import React from "react";
import { coreTheme, CoreTheme } from "sharedUI/styles";
import { ThemeProvider } from "styled-components";

interface Props {
    theme: CoreTheme;
}

function keyToVariableName(str: string): string {
    return `--gv-${str.replace(/[a-z][A-Z]/g, x =>
        x
            .split("")
            .map(c => c.toLowerCase())
            .join("-")
    )}`;
}

const keys = Object.keys(coreTheme) as (keyof CoreTheme)[];
export const TailwindThemeProvider: React.FC<Props> = p => {
    const css = React.useMemo(() => {
        const vars: Record<string, string> = {};
        for (const key of keys) {
            vars[keyToVariableName(key)] = p.theme[key];
        }
        return vars;
    }, [p.theme]);

    return (
        <ThemeProvider theme={p.theme}>
            <div style={css}>{p.children}</div>
        </ThemeProvider>
    );
};
